import { gql } from "graphql-request";

export const configurations = {
  configurations: gql`
    query Configurations {
      configurations {
        tenantId
        featureFlags {
          enabled
          available {
            flag
            description
            isTargeted
            expectedRelease
            teamOwnership
            jiraNumber
            createdDate
          }
        }
      }
    }
  `,
};
